import { ReactElement, ReactNode } from "react";

export default function TableBody(props: {
  children: ReactNode;
}): ReactElement {
  return <tbody>{props.children}</tbody>;
}
